<div class="flex h-full flex-col gap-9 bg-grey-veryLightGrey">
  <div class="absolute right-4 top-4 cursor-pointer">
    <mat-icon
      tabindex="0"
      class="material-icons-outlined hvs-icon-lg shrink-0"
      (click)="onCloseBtnClick()"
      (keydown.enter)="onCloseBtnClick()"
    >
      close
    </mat-icon>
  </div>
  <div class="px-10 pt-10">
    <h2 class="text-center text-2xl font-semibold">
      {{ headline() }}
    </h2>
  </div>
  <div class="overflow-y-auto px-10 pb-10">
    <div class="flex flex-wrap justify-center gap-8">
      <div
        class="flex w-auto flex-wrap justify-center gap-8 pt-7 lg:flex-col lg:justify-start"
      >
        <app-license-quantity-input
          [quantity]="productDataService.quantityControl.value"
          (quantityChanged)="
            productDataService.quantityControl.setValue($event);
            fetchProductDetails()
          "
          [min]="1"
          [max]="9999"
        ></app-license-quantity-input>
        <app-help-card
          class="h-fit w-[390px]"
          (supportButtonClick)="onSupportButtonClick()"
        ></app-help-card>
        <p
          class="w-[390px] whitespace-pre-line text-wrap text-sm"
          [innerHtml]="'product.dialog.atLeastOneTopicAreaRequired' | transloco"
        ></p>
        @if (isDowngradingTopicAreas) {
          <p class="w-[390px] text-wrap text-sm">
            {{ 'product.dialog.topicAreaDowngradeWarning' | transloco }}
          </p>
        }
      </div>
      <div class="flex w-full flex-wrap justify-center gap-8 xl:w-auto">
        @for (plan of plans; track plan) {
          <app-subscription-plan-card
            [loading]="plan.loading"
            [trialing]="plan.isTrialing"
            [planTranslationKey]="plan.planTranslationKey"
            [preselected]="plan.preselected"
            [unitPrice]="plan.unitPrice"
            [totalPriceWithoutTaxAndDiscount]="
              plan.totalPriceWithoutTaxAndDiscount
            "
            [(selectedTopicAreaIds)]="plan.selectedTopicAreaIds"
            (salesButtonClick)="onSalesButtonClick()"
            (fetchProductDetails)="fetchProductDetailsForPlan(plan)"
            (closeDialog)="closeDialog(plan.externalPriceId)"
          ></app-subscription-plan-card>
        }
      </div>
    </div>
  </div>
</div>
